import { NavLink, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { CalendarDays, Package, User, LogOut, Fuel } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import NotificationBell from "@/components/NotificationBell";
import { autoEnablePushIfPWA } from "@/lib/push";
import { cn } from "@/lib/utils";

const TABS = [
  { to: "/m/agenda", label: "Agenda", icon: CalendarDays },
  { to: "/m/materiali", label: "Materiali", icon: Package },
  { to: "/m/carburante", label: "Carburante", icon: Fuel },
  { to: "/m/profilo", label: "Profilo", icon: User },
];

export default function MobileLayout({ children }) {
  const { user, logout } = useAuth();
  const location = useLocation();
  useEffect(() => { autoEnablePushIfPWA(); }, []);
  const isTicketDetail = /^\/m\/tickets\/.+/.test(location.pathname);
  return (
    <div className="flex min-h-screen flex-col bg-background">
      <header className="sticky top-0 z-20 flex items-center justify-between border-b border-border bg-card px-4 py-3">
        <div className="flex items-center gap-2.5">
          <span className="flex h-9 w-9 items-center justify-center overflow-hidden rounded-lg">
            <img src="/logo-sm.png" alt="Powercom" className="h-full w-full object-contain" />
          </span>
          <div className="leading-none">
            <p className="text-sm font-extrabold tracking-tight text-navy">FLUX</p>
            <p className="text-[10px] font-bold uppercase tracking-wider text-muted-foreground">{user?.name}</p>
          </div>
        </div>
        <div className="flex items-center gap-2">
          <NotificationBell />
          <button onClick={logout} data-testid="mobile-logout" className="rounded-lg border border-border p-2 text-destructive transition-colors hover:bg-red-50">
            <LogOut size={18} />
          </button>
        </div>
      </header>

      <main className="flex-1 px-4 py-4 pb-24">{children}</main>

      <nav className={cn("fixed bottom-0 left-0 right-0 z-20 flex border-t border-border bg-card", isTicketDetail && "hidden")}>
        {TABS.map((t) => {
          const Icon = t.icon;
          return (
            <NavLink
              key={t.to}
              to={t.to}
              data-testid={`mnav-${t.label.toLowerCase()}`}
              className={({ isActive }) =>
                cn(
                  "flex flex-1 flex-col items-center gap-1 py-3 text-xs font-semibold transition-colors",
                  isActive ? "text-primary" : "text-muted-foreground"
                )
              }
            >
              <Icon size={20} />
              {t.label}
            </NavLink>
          );
        })}
      </nav>
    </div>
  );
}
